import { SalaryGroupTeacher, SalaryGroup } from '@/plugins/api'
import alert from '@/plugins/alert'
import { rangeRight } from 'lodash'
import { getListStudent, getTotalItemsStudent, fetchTeachers } from './helper/group'
import loadingCount from '@/plugins/loadingCount'
export default {
  namespaced: true,
  state: {
    students: [],
    selectedStudent: [],
    studentSearchParams: {},
    totalItems: 0,
    itemsPerPage: 5,
    pageText: '',
    loading: false,
    studentsImport: []
  },
  actions: {
    async requestPageSettings(
      { state, commit, dispatch, rootState },
      { page, itemsPerPage, defaultId, defaultType, id }
    ) {
      state.loading = true
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      if (state.studentSearchParams) {
        const studentSearchParams = {
          ...state.studentSearchParams,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          _sort: 'nameToNumber:ASC'
        }
        const group = { defaultId, defaultType, id }

        const schoolYearId = rootState.app.currentSchoolYear._id
        const students = await getListStudent({ schoolYearId, group, params: studentSearchParams })
        if (state.totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            students,
            itemsPerPage,
            studentSearchParams
          })
          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > state.totalItems || pageStop === -1 ? state.totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${state.totalItems}`
          commit('setPageText', pageText)
        } else {
          var pages = rangeRight(1, page)
          for (let index = 0; index < pages; index++) {
            const selectedPage = pages[index]
            if (state.totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
      state.loading = false
    },
    clean({ commit }) {
      commit('clean')
    },
    async delete({ state, dispatch, commit }, { id, groupId }) {
      try {
        await SalaryGroupTeacher.remove(id)
        commit('changeState', {
          totalItems: +state.totalItems - 1
        })
        alert.deleteSuccess('giáo viên')
      } catch (err) {
        alert.deleteError()
      }
      dispatch('requestPageSettings', { id: groupId, defaultType: null })
    },
    async addStudent({ rootState, dispatch, state }) {
      const groupId = rootState.salaryGroup.group._id
      const group = rootState.salaryGroup.group
      group.defaultType = null
      let list = []
      for (let item of state.selectedStudent) {
        try {
          await SalaryGroupTeacher.create({
            teacher: item,
            salary_group: groupId
          })
        } catch (e) {
          list.push(e)
        }
      }
      dispatch('getTotalStudent', group)
      dispatch('requestPageSettings', { id: groupId, defaultType: null })
      return list
    },
    async addStudentImport({ dispatch, rootState }, students) {
      const groupId = rootState.salaryGroup.group._id
      const group = rootState.salaryGroup.group
      group.defaultType = null
      const delay = ms =>
        new Promise(
          res => setTimeout(res, ms),
          () => { }
        )
      let studentError = []
      let listCode = []
      for await (const entry of students.entries()) {
        loadingCount.count(entry[0] + 1)
        try {
          listCode.push(entry[1].code)
          if (listCode.length === 10) {
            await SalaryGroup.addTeacherPack({
              groupId: groupId,
              teacherCodes: listCode
            })
            listCode = []
          } else if (entry[0] === students.length - 1 && listCode[0]) {
            await SalaryGroup.addTeacherPack({
              groupId: groupId,
              teacherCodes: listCode
            })
            listCode = []
          }
        } catch (e) {
          listCode = []
          let strError = e.replace('Giáo viên không tồn tại trên hệ thống ', '')
          let error = strError.split(',')
          studentError = studentError.concat(error)
        }
        await delay(10)
      }
      dispatch('getTotalStudent', group)
      dispatch('requestPageSettings', { id: groupId, defaultType: null })
      return studentError
    },

    async getTotalStudent({ rootState, commit }, group) {
      const schoolYearId = rootState.app.currentSchoolYear._id
      let totalItems = await getTotalItemsStudent({ schoolYearId, group })
      commit('changeState', { totalItems: totalItems })
    },
    async fetchStudentsInGroup(_, { defaultId, defaultType, id }) {
      const group = { defaultId, defaultType, id }
      const students = await fetchTeachers({ group })
      return students
    },
    async removeAllStudentInGroup(_, groupId) {
      await SalaryGroup.removeTeacher(groupId)
    },
    async resetData({ commit }) {
      commit('changeState', { students: [], totalItems: 0 })
    }
  },
  mutations: {
    setSelectedStudent(state, data) {
      state.selectedStudent = data
    },
    setPageText(state, pageText) {
      state.pageText = pageText
    },
    clean(state) {
      state.students = []
      state.studentSearchParams = {}
      state.totalItems = 0
      state.itemsPerPage = 5
    }
  },
  getters: {
    countStudents: state => state.totalItems,
    getStudents: state => state.students,
    loading: state => state.loading,
    selectedStudent: state => state.selectedStudent
  }
}
